import { twMerge } from "tailwind-merge";
import { ChevronIcon } from "@components/icons";

interface IJointBillTableRowDetailsContainerProps {
  isOpen?: boolean;
  onToggle?: () => void;
  openButtonTitle?: string;
  closeButtonTitle?: string;
  childrenContainerClassName?: string;
}

export const JointBillTableRowDetailsContainer: React.FC<
  React.PropsWithChildren<IJointBillTableRowDetailsContainerProps>
> = ({
  isOpen,
  onToggle,
  children,
  openButtonTitle,
  closeButtonTitle,
  childrenContainerClassName,
}) => {
  return (
    <div
      className={twMerge(
        "w-full overflow-hidden rounded-xl border border-grey-light bg-base-white md:rounded-2xl",
        !isOpen && "rounded-full md:rounded-2xl",
      )}
    >
      <button
        className={twMerge(
          "flex w-full items-center justify-between border-grey-light px-4 py-2.5 md:hidden",
          isOpen && "rounded-t-xl border-b",
          !isOpen && "rounded-full",
        )}
        onClick={onToggle}
      >
        <span className="text-sm font-semibold">
          {isOpen ? closeButtonTitle : openButtonTitle}
        </span>
        <ChevronIcon className={twMerge("h-4 w-4", isOpen && "rotate-180")} />
      </button>
      {isOpen && (
        <div className={twMerge("p-4 md:p-6", childrenContainerClassName)}>
          {children}
        </div>
      )}
    </div>
  );
};
